@if (loading) {
    <div class="page"><app-spinner [fullscreen]="false"></app-spinner></div>
} @else if (error) {
    <app-error-ficha [mensaje]="error" (reintentar)="loadData()" (volver)="volverAlListado()"></app-error-ficha>
} @else {
    @if (showEdit) {
        <div class="page page--form">
            <app-formulario
                [title]="'Editar ejercicio'"
                [buttons]="buttons"
                [fields]="fields"
                [type]="type"
                [functionSelected]="FunctionsAvailable.ejerciciosPut">
            </app-formulario>
        </div>
    } @else {
        <div class="page">
            <section class="ficha-hero" data-seccion="ejercicios" aria-labelledby="ficha-titulo">
                <div class="ficha-hero__back">
                    <button type="button" class="back-link" data-testid="volver" (click)="goBack()"><i class="bi bi-arrow-left" aria-hidden="true"></i>Volver a ejercicios</button>
                </div>
                <div class="ficha-hero__top">
                    <span class="page-header__icon ficha-hero__icon" data-seccion="ejercicios" aria-hidden="true"><i class="bi bi-calendar-fill"></i></span>
                    <div class="ficha-hero__id">
                        <h1 id="ficha-titulo">Ejercicio {{ item.ejercicio }}</h1>
                        @if (item.active) { <span class="badge text-bg-primary" data-testid="ejercicio-vigente"><i class="bi bi-star-fill me-1" aria-hidden="true"></i>Ejercicio vigente</span> }
                    </div>
                    <div class="ficha-hero__actions">
                        <div class="dropdown">
                            <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="bi bi-three-dots-vertical" aria-hidden="true"></i>Acciones
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li><button type="button" class="dropdown-item" (click)="editItem()"><i class="bi bi-pencil-square" aria-hidden="true"></i>Editar</button></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="tabs" role="tablist" aria-label="Contenido del ejercicio" appTabsNav>
                    <button type="button" role="tab" class="tab" id="tab-asociaciones" data-testid="pestana-asociaciones" [attr.aria-selected]="viewMode === ViewModeEjercicio.ASOCIACIONES" [attr.tabindex]="viewMode === ViewModeEjercicio.ASOCIACIONES ? 0 : -1" (click)="cambiarVista(ViewModeEjercicio.ASOCIACIONES)">Asociaciones</button>
                    <button type="button" role="tab" class="tab" id="tab-asociados" data-testid="pestana-asociados" [attr.aria-selected]="viewMode === ViewModeEjercicio.ASOCIADOS" [attr.tabindex]="viewMode === ViewModeEjercicio.ASOCIADOS ? 0 : -1" (click)="cambiarVista(ViewModeEjercicio.ASOCIADOS)">Asociados</button>
                </div>
            </section>

            @if (viewMode === 'asociaciones') {
                <div role="tabpanel" aria-labelledby="tab-asociaciones">
                    <app-listado
                        [items]="asociaciones"
                        [type]="ItemType.ASOCIACIONES"
                        (openItem)="emitOpenItem($event, 'Asociaciones', item)"
                    ></app-listado>
                </div>
            } @else {
                <div role="tabpanel" aria-labelledby="tab-asociados">
                    <app-ejercicio-asociados [ejercicioId]="item.id!"></app-ejercicio-asociados>
                </div>
            }
        </div>
    }
}
